import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// store
import {
	setSort,
	setLocation,
	toggleLocationModal,
	setLoader,
	setLoading,
} from "../../../configureStore";
// helpers
import location from "../../../helper/location";
import isObjectEmpty from "../../../helper/emptyObj";
const LocationBtn = (props) => {
	const dispatch = useDispatch();
	const [active, setActive] = useState(false);
	const [locationData, setLocationData] = useState({});
	useEffect(() => {
		if(props.searchData.locationChecked && !props.searchData.location.hasOwnProperty('blocked')) {
			setActive(true);
			setLocationData(props.searchData.location);
		} else {
			setActive(false);
			setLocationData({});
		}
	},[props.searchData.locationChecked])

	const getLocation = async () => {
		if (!isObjectEmpty(locationData) && active) {
			// uncheck location if there is data
			setActive(false);
			await dispatch(setSort({ value: "az" }));
			await dispatch(setLocation({ location: {}, checked: false }));
			if (window.initialState.page === "search") {
				dispatch(setLoading(true));
			}
			return;
		} else if (!isObjectEmpty(locationData) && !active) {
			// check location if there is data
			setActive(true);
			await dispatch(setSort({ value: "distance" }));
			await dispatch(setLocation({ location: locationData, checked: true }));
			if (window.initialState.page === "search") {
				dispatch(setLoading(true));
			}
			return;
		}
		if (!active) {
			try {
				dispatch(setLoader(true));
				const response = await location();
				const latitude = response.coords.latitude;
				const longitude = response.coords.longitude;

				if(!latitude && !longitude)  return;
				const coordsObj = {
					lat: latitude,
					lng: longitude,
				};
				setActive(true);
				setLocationData(coordsObj);
				await dispatch(setSort({ value: "distance" }));
				await dispatch(setLocation({ location: coordsObj, checked: true }));
				if (window.initialState.page === "search") {
					dispatch(setLoading(true));
				} else  {
					dispatch(setLoader(false));
				}
			} catch (err) {
				dispatch(setLocation({ location: { blocked: true }, checked: true }));
				dispatch(setLoader(false));
				dispatch(toggleLocationModal("true"));
				console.error(err.message);
			}
		}
	};

	return (
		<>
			<button
				type="button"
				className={`button-icon-cta ${active ? "is-active" : ""}`}
				aria-label="location btn"
				onClick={getLocation}>
				<svg
					width="21"
					height="21"
					viewBox="0 0 21 21"
					fill="#3642AE"
					xmlns="http://www.w3.org/2000/svg">
					<g>
						<path d="M9.69353 20.8147V19.1206C7.92849 18.923 6.41422 18.1926 5.15073 16.9294C3.88667 15.6656 3.1558 14.1514 2.95812 12.3868H1.26367V10.6927H2.95812C3.1558 8.92806 3.88667 7.41385 5.15073 6.15009C6.41422 4.88689 7.92849 4.15647 9.69353 3.95883V2.26477H11.388V3.95883C13.153 4.15647 14.6676 4.88689 15.9316 6.15009C17.1951 7.41385 17.9257 8.92806 18.1234 10.6927H19.8178V12.3868H18.1234C17.9257 14.1514 17.1951 15.6656 15.9316 16.9294C14.6676 18.1926 13.153 18.923 11.388 19.1206V20.8147H9.69353ZM10.5408 17.4689C12.1787 17.4689 13.5766 16.8901 14.7345 15.7325C15.8924 14.5749 16.4713 13.1773 16.4713 11.5397C16.4713 9.90214 15.8924 8.50454 14.7345 7.34694C13.5766 6.18933 12.1787 5.61053 10.5408 5.61053C8.90279 5.61053 7.50488 6.18933 6.34701 7.34694C5.18914 8.50454 4.6102 9.90214 4.6102 11.5397C4.6102 13.1773 5.18914 14.5749 6.34701 15.7325C7.50488 16.8901 8.90279 17.4689 10.5408 17.4689ZM10.5408 14.9278C9.60881 14.9278 8.81101 14.5961 8.14735 13.9326C7.4837 13.2691 7.15187 12.4715 7.15187 11.5397C7.15187 10.608 7.4837 9.81038 8.14735 9.14687C8.81101 8.48337 9.60881 8.15162 10.5408 8.15162C11.4727 8.15162 12.2705 8.48337 12.9342 9.14687C13.5978 9.81038 13.9296 10.608 13.9296 11.5397C13.9296 12.4715 13.5978 13.2691 12.9342 13.9326C12.2705 14.5961 11.4727 14.9278 10.5408 14.9278ZM10.5408 13.2338C11.0067 13.2338 11.4058 13.0678 11.7379 12.7357C12.0694 12.4043 12.2352 12.0056 12.2352 11.5397C12.2352 11.0739 12.0694 10.6749 11.7379 10.3429C11.4058 10.0114 11.0067 9.84567 10.5408 9.84567C10.0748 9.84567 9.67602 10.0114 9.34448 10.3429C9.01237 10.6749 8.84631 11.0739 8.84631 11.5397C8.84631 12.0056 9.01237 12.4043 9.34448 12.7357C9.67602 13.0678 10.0748 13.2338 10.5408 13.2338Z" />
					</g>
				</svg>
			</button>
		</>
	);
};
export default LocationBtn;
